'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $f_s_Product11__productElement__I__O($thiz, n) {
  switch (n) {
    case 0: {
      return $thiz.my;
      break;
    }
    case 1: {
      return $thiz.mB;
      break;
    }
    case 2: {
      return $thiz.mC;
      break;
    }
    case 3: {
      return $thiz.mD;
      break;
    }
    case 4: {
      return $thiz.mE;
      break;
    }
    case 5: {
      return $thiz.mF;
      break;
    }
    case 6: {
      return $thiz.mG;
      break;
    }
    case 7: {
      return $thiz.mH;
      break;
    }
    case 8: {
      return $thiz.mI;
      break;
    }
    case 9: {
      return $thiz.mz;
      break;
    }
    case 10: {
      return $thiz.mA;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), (n + " is out of bounds (min 0, max 10)"));
    }
  }
}
export { $f_s_Product11__productElement__I__O as $f_s_Product11__productElement__I__O };
